/**
 * Fixed message the connected wallet signs to derive the trading key.
 * Deliberately static (no nonce/timestamp) - signing twice with the same
 * wallet produces the same signature / trading key.
 */
export const TRADING_KEY_WALLET_MESSAGE =
  "sme-platform prediction-market trading key v1 - signing this derives your trading key; it does not move funds.";

function bytesToHex(bytes) {
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

/**
 * `0x`-hex of `TRADING_KEY_WALLET_MESSAGE` UTF-8 bytes for `dusk_signMessage`.
 * Hex (not Uint8Array) so JSON-serialized extension RPC params stay valid.
 */
export function tradingKeyWalletMessageHex() {
  return `0x${bytesToHex(new TextEncoder().encode(TRADING_KEY_WALLET_MESSAGE))}`;
}
